import React from 'react'
import { storiesOf } from '@storybook/react'
import { Match as MatchProto, MatchStatus, Team, BetOffer, MatchPeriod } from 'protos'

import MatchCard from 'components/MatchCard'

import dummyProviderLogo from './assets/dummy_provider_logo.svg'

const exampleMatch = MatchProto.create({
  status: MatchStatus.MS_UPCOMING,
  kickoff: Math.round(Date.now() / 1000) + 3600000,
  kickoffRemainingSec: 3600,
  homeTeam: Team.create({ name: 'Chelsea' }),
  awayTeam: Team.create({ name: 'Manchester United' }),
})

const matchWithLongTeamNames = {
  ...exampleMatch,
  homeTeam: Team.create({ name: 'Bosnia and Herzegovina' }),
  awayTeam: Team.create({ name: 'Democratic Republic of the Congo' }),
}

const liveMatch = MatchProto.create({
  status: MatchStatus.MS_LIVE,
  kickoff: Math.round(Date.now() / 1000),
  homeTeam: Team.create({ name: 'Chelsea' }),
  awayTeam: Team.create({ name: 'Manchester United' }),
  clock: {
    extra: 0,
    minute: 1,
    second: 0,
  },
  period: MatchPeriod.MP_FIRST_HALF,
})

const matchWithBetOffer = {
  ...exampleMatch,
  betOffer: BetOffer.create({
    home: {
      odd: '1.25',
      url: 'https://tackl.me'
    },
    draw: {
      odd: null,
      url: 'https://tackl.me'
    },
    away: {
      odd: '8',
      url: 'https://tackl.me'
    },
    providerLogo: dummyProviderLogo
  })
}

storiesOf('MatchCard', module)
  .add('default', () => (
    <div style={{ padding: 20 }}>
      <MatchCard match={exampleMatch} />
    </div>
  ))
  .add('with long team names', () => (
    <div style={{ padding: 20 }}>
      <MatchCard match={matchWithLongTeamNames} />
    </div>
  ))
  .add('with bet offer', () => (
    <div style={{ padding: 20 }}>
      <MatchCard match={matchWithBetOffer} />
    </div>
  ))
  .add('live', () => (
    <div style={{ padding: 20 }}>
      <MatchCard match={liveMatch} />
    </div>
  ))
